import logo from './logo.svg';
import './App.css';
import ChoiceBox from './ChoiceBox';

function App() {
  return (
    <>
      <ChoiceBox />
    </>
  );
}

export default App;
